import script from "./mobile-bottom-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile-bottom-bar.vue?vue&type=script&setup=true&lang=js"

import "./mobile-bottom-bar.vue?vue&type=style&index=0&id=40f34098&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f34098"]])

export default __exports__